module.exports = __webpack_public_path__ + "img/01a27b7.png";